import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { LottieAnimation } from "lottie-web-vue"

export default /*@__PURE__*/_defineComponent({
  __name: 'LottieObject',
  props: {
        class: {type: String},
        jsonFile: {type: String},
        autoPlay: {type: Boolean, default: true},
        loop: {type: Boolean, default: true},
        speed: {type: Number, default: 1}
    },
  setup(__props) {

    
    
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(__props.class)
  }, [
    _createVNode(_unref(LottieAnimation), {
      class: "lottie-wrapper",
      "animation-data": require('@/assets/lottie/' + __props.jsonFile),
      "auto-play": __props.autoPlay,
      loop: __props.loop,
      speed: __props.speed,
      ref: "anim"
    }, null, 8, ["animation-data", "auto-play", "loop", "speed"]),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})